import styled from 'styled-components';

export const DEIPageDonutChartDIV = styled.div`
  position: relative;
`;

export const DEIPageDonutChartCIRCLE = styled.circle`
  transition: all 0.3s;
`;

export const DEIPageDonutChartPercentageOverlayDIV = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  text-align: center;

  h4 {
    color: var(--color--charcoal-1100);
    margin: 0;
  }

  p {
    color: var(--color--charcoal-700);
    line-height: 1.2;
    margin-bottom: 30px;
  }
`;